import { TopBar } from "component_old/macro/layout/landing/hero/TopBar"
import { ImageMask } from "component_old/micro/design/ImageMask"
import { S_DesktopOnly } from "component_old/micro/responsive/responsive"
import { H1, S_H1 } from "component_old/micro/view/H1"
import { SVG_Cover_PC_L, S_SVG_Cover_PC_L } from "libs/images/SVG_Cover_PC_L"
import { SVG_Cover_PC_R, S_SVG_Cover_PC_R } from "libs/images/SVG_Cover_PC_R"
import { EGrads } from "libs/style/styling"
import { TextContent } from "libs/types/TextContent"
import React from "react"
import styled from "styled-components/macro"

interface Props {
  content?: TextContent
  text?: string
}

export const TextHeaderWide = (props: Props): JSX.Element => {
  const hasText = Boolean(props.text)

  return (
    <S_DesktopOnly>
      <S_LandingHeroPcOuter hasText={hasText}>
        {/* <S_TopGrad /> */}
        <ImageMask
          randomizePosition={true}
          image="building"
          step={0}
          degress={180}
          initOpacity={0.05}
          finalOpacity={0.9}
          repeat={false}
          positionX="center"
          positionY="bottom -760px"
        />
        <S_LandingHeroPc>
          <S_Body>
            <TopBar />
            {hasText && (
              <H1>
                {props.content === "terms" && <>Terms and Conditions</>}
                {props.content === "privacy" && <>Privacy Policy</>}
                {props.content === "industriuka-terms" && (
                  <>Industriuka App Terms and Conditions </>
                )}
                {props.content === "industriuka-privacy" && (
                  <>Industriuka App Privacy Policy</>
                )}
                {props.content === "mapheim-terms" && (
                  <>App Terms and Conditions </>
                )}
                {props.content === "mapheim-privacy" && <>App Privacy Policy</>}
                {props.text}
              </H1>
            )}
          </S_Body>
          <SVG_Cover_PC_L />
          <SVG_Cover_PC_R />
        </S_LandingHeroPc>
      </S_LandingHeroPcOuter>
    </S_DesktopOnly>
  )
}

const S_LandingHeroPcOuter = styled.div<{ hasText: boolean }>`
  max-width: 1920px;
  width: 100%;
  height: ${props => (props.hasText ? "380px" : "auto")};
  margin: auto;
  background: ${EGrads.PRIM_GRAD};
  position: relative;
  overflow: hidden;
`

export const S_LandingHeroPc = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 30px 0;
  position: relative;
  max-width: 1260px;
  width: 100%;
  height: 100%;
  ${S_SVG_Cover_PC_L} {
    position: absolute;
    top: -30px;
    left: -330px;
  }
  ${S_SVG_Cover_PC_R} {
    position: absolute;
    top: -30px;
    right: -330px;
  }
`

const S_Body = styled.div`
  z-index: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  ${S_H1} {
    margin: 100px 0 0 0;
  }
`

const S_TopGrad = styled.div`
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  height: 350px;
  background: linear-gradient(180deg, #262c67 0%, #43498400 100%);
`
